// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__9pr2E","text":"style_text__a4JzK","description":"style_description__nZP9s"};